module.exports = __webpack_public_path__ + "img/logo_white.5835adf2.svg";